"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.UIConfigSchema = exports.ExtendedResponseTapeUploadSchema = exports.nodeType = void 0;
const v4_1 = require("zod/v4");
exports.nodeType = 'file_generatedBorrowingBaseReport';
// every node must export UIConfig.
// this type describes the configuration
// for the node as seen on tape-builder UI.
// there must also be a json schema associated with it.
exports.ExtendedResponseTapeUploadSchema = v4_1.z.object({
    loanProductSlug: v4_1.z
        .string()
        .describe('Extended response tape is generated for each loan product. Specify the loanProduct and the upload path for the corresponding extended response tape.'),
    uploadPath: v4_1.z
        .string()
        .describe('Upload path for the corresponding extended response tape.'),
});
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    description: v4_1.z.string().describe('Description'),
    createServicerReport: v4_1.z
        .boolean()
        .describe('Determines if a servicerReport will be generated on every loan tape upload.'),
    fundingSubmissionArtifactSlug: v4_1.z.string().optional()
        .describe(`For providing funding request amount for explicit proforma borrowing base reserve expects a 1 line csv with headers:
    'drawRequest#totalAmount'
    'drawRequest#targetFundingDate'
    'collectionsRecycle#totalAmount'
    'collectionsRecycle#targetFundingDate'
    'collectionsPaydown#totalAmount'
    'collectionsPaydown#targetFundingDate'
    'curePaydown#totalAmount'
    'curePaydown#targetFundingDate'
   `),
    extendedResponseTapeUploads: v4_1.z
        .array(exports.ExtendedResponseTapeUploadSchema)
        .optional()
        .describe('This can be set to upload the generated extended response tape to internal-customer-raw-data bucket.'),
});
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
// Zod schema and type for IntermediateRecordConfig
exports.IntermediateRecordConfigSchema = v4_1.z.object({
    operationDescription: v4_1.z
        .string()
        .optional()
        .describe('this prop is deprecated. It will not be generated by tape-builder. But marking it optional so that existing records can be validated.'),
    tapeDescription: v4_1.z.string().describe('this will show up in tape node.'),
    createServicerReport: v4_1.z
        .boolean()
        .optional()
        .describe('this will show up in tape node.'),
    fundingSubmissionArtifactSlug: v4_1.z
        .string()
        .optional()
        .describe('Marked as optional because older records do not have this field. If migration is desired, update all missing records to use `null` instead'),
    extendedResponseTapeUploads: v4_1.z
        .array(v4_1.z.object({
        loanProductSlug: v4_1.z.string(),
        uploadPath: v4_1.z.string(),
    }))
        .optional(),
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database.
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
// well not completely, because it may be modified by synthetic node creation
// later.
exports.artifactType = 'borrowingBaseReport';
//# sourceMappingURL=types.js.map